function gm_authFailure() {
    Shopify.designMode &&
        (theme.$currentMapContainer.addClass("page-width map-section--load-error"),
        theme.$currentMapContainer.find(".map-section__content-wrapper").remove(),
        theme.$currentMapContainer.find(".map-section__wrapper").html('<div class="errors text-center" style="width: 100%;">' + theme.strings.authError + "</div>"));
}
(window.theme = window.theme || {}),
    (window.slate = window.slate || {}),
    (theme.Sections = function () {
        (this.constructors = {}),
            (this.instances = []),
            $(document)
                .on("shopify:section:load", this._onSectionLoad.bind(this))
                .on("shopify:section:unload", this._onSectionUnload.bind(this))
                .on("shopify:section:select", this._onSelect.bind(this))
                .on("shopify:section:deselect", this._onDeselect.bind(this))
                .on("shopify:block:select", this._onBlockSelect.bind(this))
                .on("shopify:block:deselect", this._onBlockDeselect.bind(this));
    }),
    (theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
        _createInstance: function (e, t) {
            var i = $(e),
                n = i.attr("data-section-id"),
                a = i.attr("data-section-type");
            if (((t = t || this.constructors[a]), !_.isUndefined(t))) {
                var o = _.assignIn(new t(e), { id: n, type: a, container: e });
                this.instances.push(o);
            }
        },
        _onSectionLoad: function (e) {
            var t = $("[data-section-id]", e.target)[0];
            t && this._createInstance(t);
        },
        _onSectionUnload: function (e) {
            this.instances = _.filter(this.instances, function (t) {
                var i = t.id === e.detail.sectionId;
                return i && _.isFunction(t.onUnload) && t.onUnload(e), !i;
            });
        },
        _onSelect: function (e) {
            var t = _.find(this.instances, function (t) {
                return t.id === e.detail.sectionId;
            });
            !_.isUndefined(t) && _.isFunction(t.onSelect) && t.onSelect(e);
        },
        _onDeselect: function (e) {
            var t = _.find(this.instances, function (t) {
                return t.id === e.detail.sectionId;
            });
            !_.isUndefined(t) && _.isFunction(t.onDeselect) && t.onDeselect(e);
        },
        _onBlockSelect: function (e) {
            var t = _.find(this.instances, function (t) {
                return t.id === e.detail.sectionId;
            });
            !_.isUndefined(t) && _.isFunction(t.onBlockSelect) && t.onBlockSelect(e);
        },
        _onBlockDeselect: function (e) {
            var t = _.find(this.instances, function (t) {
                return t.id === e.detail.sectionId;
            });
            !_.isUndefined(t) && _.isFunction(t.onBlockDeselect) && t.onBlockDeselect(e);
        },
        register: function (e, t) {
            (this.constructors[e] = t),
                $("[data-section-type=" + e + "]").each(
                    function (e, i) {
                        this._createInstance(i, t);
                    }.bind(this)
                );
        },
    })),
    (window.slate = window.slate || {}),
    (slate.rte = {
        wrapTable: function () {
            $(".rte table").wrap('<div class="rte__table-wrapper"></div>');
        },
        iframeReset: function () {
            var e = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]'),
                t = e.add(".rte iframe#admin_bar_iframe");
            e.each(function () {
                $(this).wrap('<div class="video-wrapper"></div>');
            }),
                t.each(function () {
                    this.src = this.src;
                });
        },
    }),
    (window.slate = window.slate || {}),
    (slate.a11y = {
        pageLinkFocus: function (e) {
            var t = "js-focus-hidden";
            e.first()
                .attr("tabIndex", "-1")
                .focus()
                .addClass(t)
                .one("blur", function () {
                    e.first().removeClass(t).removeAttr("tabindex");
                });
        },
        focusHash: function () {
            var e = window.location.hash;
            e && document.getElementById(e.slice(1)) && this.pageLinkFocus($(e));
        },
        bindInPageLinks: function () {
            $("a[href*=#]").on(
                "click",
                function (e) {
                    this.pageLinkFocus($(e.currentTarget.hash));
                }.bind(this)
            );
        },
        trapFocus: function (e) {
            var t = e.namespace ? "focusin." + e.namespace : "focusin";
            e.$elementToFocus || (e.$elementToFocus = e.$container),
                e.$container.attr("tabindex", "-1"),
                e.$elementToFocus.focus(),
                $(document).on(t, function (t) {
                    e.$container[0] === t.target || e.$container.has(t.target).length || e.$container.focus();
                });
        },
        removeTrapFocus: function (e) {
            var t = e.namespace ? "focusin." + e.namespace : "focusin";
            e.$container && e.$container.length && e.$container.removeAttr("tabindex"), $(document).off(t);
        },
    }),
    (theme.Currency = (function () {
        var e = "${{amount}}";
        return {
            formatMoney: function (t, i) {
                "string" == typeof t && (t = t.replace(".", ""));
                var n = "",
                    a = /\{\{\s*(\w+)\s*\}\}/,
                    o = i || e;
                function s(e, t, i, n) {
                    if (((i = i || ","), (n = n || "."), isNaN(e) || null === e)) return 0;
                    var a = (e = (e / 100).toFixed(t)).split(".");
                    return a[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) + (a[1] ? n + a[1] : "");
                }
                switch (o.match(a)[1]) {
                    case "amount":
                        n = s(t, 2);
                        break;
                    case "amount_no_decimals":
                        n = s(t, 0);
                        break;
                    case "amount_with_comma_separator":
                        n = s(t, 2, ".", ",");
                        break;
                    case "amount_no_decimals_with_comma_separator":
                        n = s(t, 0, ".", ",");
                        break;
                    case "amount_no_decimals_with_space_separator":
                        n = s(t, 0, " ");
                        break;
                    case "amount_with_apostrophe_separator":
                        n = s(t, 2, "'");
                }
                return o.replace(a, n);
            },
        };
    })()),
    (theme.Images = (function () {
        return {
            preload: function (e, t) {
                "string" == typeof e && (e = [e]);
                for (var i = 0; i < e.length; i++) {
                    var n = e[i];
                    this.loadImage(this.getSizedImageUrl(n, t));
                }
            },
            loadImage: function (e) {
                new Image().src = e;
            },
            switchImage: function (e, t, i) {
                var n = this.imageSize(t.src),
                    a = this.getSizedImageUrl(e.src, n);
                i ? i(a, e, t) : (t.src = a);
            },
            imageSize: function (e) {
                var t = (e = e || "").match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/);
                return null === t ? null : t[1];
            },
            getSizedImageUrl: function (e, t) {
                if (null === t) return e;
                if ("master" === t) return this.removeProtocol(e);
                var i = e.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
                if (null !== i) {
                    var n = e.split(i[0]),
                        a = i[0];
                    return this.removeProtocol(n[0] + "_" + t + a);
                }
                return null;
            },
            removeProtocol: function (e) {
                return e.replace(/http(s)?:/, "");
            },
        };
    })()),
    (slate.Variants = (function () {
        function e(e) {
            (this.$container = e.$container),
                (this.product = e.product),
                (this.singleOptionSelector = e.singleOptionSelector),
                (this.originalSelectorId = e.originalSelectorId),
                (this.enableHistoryState = e.enableHistoryState),
                (this.currentVariant = this._getVariantFromOptions()),
                $(this.singleOptionSelector, this.$container).on("change", this._onSelectChange.bind(this));
        }
        return (
            (e.prototype = _.assignIn({}, e.prototype, {
                _getCurrentOptions: function () {
                    var e = _.map($(this.singleOptionSelector, this.$container), function (e) {
                        var t = $(e),
                            i = t.attr("type"),
                            n = {};
                        return "radio" === i || "checkbox" === i ? !!t[0].checked && ((n.value = t.val()), (n.index = t.data("index")), n) : ((n.value = t.val()), (n.index = t.data("index")), n);
                    });
                    return (e = _.compact(e));
                },
                _getVariantFromOptions: function () {
                    var e = this._getCurrentOptions(),
                        t = this.product.variants;
                    return _.find(t, function (t) {
                        return e.every(function (e) {
                            return _.isEqual(t[e.index], e.value);
                        });
                    });
                },
                _onSelectChange: function () {
                    var e = this._getVariantFromOptions();
                    this.$container.trigger({ type: "variantChange", variant: e }),
                        e && (this._updateMasterSelect(e), this._updateImages(e), this._updatePrice(e), this._updateSKU(e), (this.currentVariant = e), this.enableHistoryState && this._updateHistoryState(e));
                },
                _updateImages: function (e) {
                    var t = e.featured_image || {},
                        i = this.currentVariant.featured_image || {};
                    e.featured_image && t.src !== i.src && this.$container.trigger({ type: "variantImageChange", variant: e });
                },
                _updatePrice: function (e) {
                    (e.price === this.currentVariant.price && e.compare_at_price === this.currentVariant.compare_at_price) || this.$container.trigger({ type: "variantPriceChange", variant: e });
                },
                _updateSKU: function (e) {
                    e.sku !== this.currentVariant.sku && this.$container.trigger({ type: "variantSKUChange", variant: e });
                },
                _updateHistoryState: function (e) {
                    if (history.replaceState && e) {
                        var t = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + e.id;
                        window.history.replaceState({ path: t }, "", t);
                    }
                },
                _updateMasterSelect: function (e) {
                    $(this.originalSelectorId, this.$container).val(e.id);
                },
            })),
            e
        );
    })()),
    (window.Drawers = (function () {
        var e = function (e, t, i) {
            var n = { close: ".js-drawer-close", open: ".js-drawer-open-" + t, openClass: "js-drawer-open", dirOpenClass: "js-drawer-open-" + t };
            if (
                ((this.nodes = { $parent: $("body, html"), $page: $(".page-element"), $moved: $(".is-moved-by-drawer") }),
                (this.config = $.extend(n, i)),
                (this.position = t),
                (this.$drawer = $("#" + e)),
                (this.$open = $(this.config.open)),
                !this.$drawer.length)
            )
                return !1;
            (this.drawerIsOpen = !1), this.init();
        };
        return (
            (e.prototype.init = function () {
                this.$open.attr("aria-expanded", "false"), this.$open.on("click", $.proxy(this.open, this)), this.$drawer.find(this.config.close).on("click", $.proxy(this.close, this));
            }),
            (e.prototype.open = function (e) {
                var t = !1;
                if (!this.drawerIsOpen) {
                    if ((this.$open.addClass(this.config.openClass), e ? e.preventDefault() : (t = !0), e && e.stopPropagation && (e.stopPropagation(), (this.$activeSource = $(e.currentTarget))), this.drawerIsOpen && !t))
                        return this.close();
                    this.nodes.$moved.addClass("is-transitioning"),
                        this.$drawer.prepareTransition(),
                        this.nodes.$parent.addClass(this.config.openClass + " " + this.config.dirOpenClass),
                        (this.drawerIsOpen = !0),
                        slate.a11y.trapFocus({ $container: this.$drawer, namespace: "drawer_focus" }),
                        this.config.onDrawerOpen && "function" == typeof this.config.onDrawerOpen && (t || this.config.onDrawerOpen()),
                        this.$activeSource && this.$activeSource.attr("aria-expanded") && this.$activeSource.attr("aria-expanded", "true"),
                        this.bindEvents();
                }
            }),
            (e.prototype.close = function () {
                this.drawerIsOpen &&
                    (this.$open.removeClass(this.config.openClass),
                    $(document.activeElement).trigger("blur"),
                    this.nodes.$moved.prepareTransition({ disableExisting: !0 }),
                    this.$drawer.prepareTransition({ disableExisting: !0 }),
                    this.nodes.$parent.removeClass(this.config.dirOpenClass + " " + this.config.openClass),
                    (this.drawerIsOpen = !1),
                    slate.a11y.removeTrapFocus({ $container: this.$drawer, namespace: "drawer_focus" }),
                    this.$activeSource && this.$activeSource.attr("aria-expanded") && this.$activeSource.attr("aria-expanded", "false"),
                    this.unbindEvents());
            }),
            (e.prototype.bindEvents = function () {
                this.nodes.$page.on("touchmove.drawer", function () {
                    return !1;
                }),
                    this.nodes.$page.on(
                        "click.drawer",
                        $.proxy(function () {
                            return this.close(), !1;
                        }, this)
                    ),
                    this.nodes.$parent.on(
                        "keyup.drawer",
                        $.proxy(function (e) {
                            27 === e.keyCode && this.close();
                        }, this)
                    );
            }),
            (e.prototype.unbindEvents = function () {
                this.nodes.$page.off(".drawer"), this.nodes.$parent.off(".drawer");
            }),
            e
        );
    })()),
    (theme.Hero = (function () {
        var e = {
                hero: ".hero",
                heroWrapper: ".hero-wrapper",
                heroContent: ".hero-content",
                heroTitle: ".hero-content__title",
                heroPause: ".hero__pause",
                heroAdapt: ".hero--adapt",
                heroControlsArrow: ".hero-content__controls-item--arrow",
                heroControlsCount: ".hero-content__controls-item--count",
                heroControlsText: ".hero-content__controls-item--text",
            },
            t = "hero-content-active",
            i = "hero-title-active",
            n = "hero-link-active",
            a = "is-paused";
        function o(t) {
            (this.namespace = ".hero"),
                (this.$hero = $(t)),
                (this.$wrapper = this.$hero.closest(e.heroWrapper)),
                (this.$heroContent = this.$wrapper.find(e.heroContent)),
                (this.$heroPause = this.$wrapper.find(e.heroPause)),
                (this.$heroControlsArrow = this.$wrapper.find(e.heroControlsArrow)),
                (this.$heroAdapt = this.$wrapper.find(e.heroAdapt)),
                this.$hero.on("init" + this.namespace, this._a11y.bind(this)),
                this.$hero.on("init" + this.namespace, this._arrowsInit.bind(this)),
                this.$hero.on("init reInit afterChange" + this.namespace, this._countSlide.bind(this)),
                this.$hero.on("init reInit afterChange" + this.namespace, this._showActiveContent.bind(this)),
                this.$hero.on("init reInit afterChange" + this.namespace, this._showContent.bind(this)),
                this.$hero.on("beforeChange" + this.namespace, this._hideContent.bind(this));
            var i = this.$hero.data("adapt-height");
            this.$hero.slick({ accessibility: !0, arrows: !1, draggable: !1, autoplay: this.$hero.data("autoplay"), autoplaySpeed: this.$hero.data("speed") }),
                i && (this._setSlideshowHeight(), $(window).resize($.debounce(50, this._setSlideshowHeight.bind(this)))),
                this.$heroPause.on("click" + this.namespace, this._togglePause.bind(this));
        }
        return (
            (o.prototype = _.assignIn({}, o.prototype, {
                _setSlideshowHeight: function () {
                    var e = this.$hero.data("min-aspect-ratio");
                    this.$hero.height(this.$heroAdapt.width() / e);
                },
                _countSlide: function (t, i, n) {
                    var a = (n || 0) + 1,
                        o = this.$wrapper.find(e.heroControlsCount);
                    i.slideCount > 1 && (o.attr("aria-label", theme.strings.slideNumber.replace("[slide_number]", a)), o.children(".slide-counter").text(a + "/" + i.slideCount));
                },
                _showActiveContent: function (t, a, o) {
                    o = o || 0;
                    var s = this.$wrapper.find(e.heroControlsText),
                        r = this.$wrapper.find(e.heroTitle);
                    if (a.slideCount > 1) {
                        var c = r.filter('[data-slide-id="' + (o + 1) + '"]'),
                            l = s.filter('[data-slide-id="' + (o + 1) + '"]');
                        r.removeClass(i), c.addClass(i), s.removeClass(n), l.addClass(n);
                    }
                },
                _hideContent: function () {
                    this.$heroContent.removeClass(t);
                },
                _showContent: function () {
                    this.$heroContent.addClass(t);
                },
                _togglePause: function () {
                    if (this.$heroPause.hasClass(a)) {
                        var e = this.$heroPause.data("label-pause");
                        this.$heroPause.removeClass(a).attr({ "aria-pressed": "false", "aria-label": e }), this.play();
                    } else {
                        var t = this.$heroPause.data("label-play");
                        this.$heroPause.addClass(a).attr({ "aria-pressed": "true", "aria-label": t }), this.pause();
                    }
                },
                _a11y: function (t, i) {
                    var n = i.$list,
                        o = $(t.currentTarget).parents(e.heroWrapper),
                        s = this.$hero.data("autoplay");
                    n.removeAttr("aria-live"),
                        this.$heroContent.removeAttr("aria-live"),
                        o
                            .on(
                                "focusin" + this.namespace,
                                function (e) {
                                    o.has(e.target).length && (this.$heroContent.attr("aria-live", "polite"), s && this.pause());
                                }.bind(this)
                            )
                            .on(
                                "focusout" + this.namespace,
                                function (e) {
                                    o.has(e.relatedTarget).length || (this.$heroContent.removeAttr("aria-live"), s && !this.$heroPause.hasClass(a) && this.play());
                                }.bind(this)
                            )
                            .on("keyup", this._keyboardNavigation.bind(this));
                },
                _arrowsInit: function (e, t) {
                    var i = t.slideCount,
                        n = t.$slider,
                        a = this.$heroControlsArrow;
                    a.length && i > 1
                        ? a.on(
                              "click" + this.namespace,
                              function (e) {
                                  e.preventDefault();
                                  var t = $(e.currentTarget).find("button").data("control");
                                  "previous" === t ? n.slick("slickPrev") : "next" === t && n.slick("slickNext"), this._scrollTop();
                              }.bind(this)
                          )
                        : a.remove();
                },
                _scrollTop: function () {
                    var e = $(document).scrollTop(),
                        t = this.$hero.offset().top;
                    e > t && $("html").add("body").animate({ scrollTop: t }, 250);
                },
                _keyboardNavigation: function (e) {
                    37 === e.keyCode && this.$hero.slick("slickPrev"), 39 === e.keyCode && this.$hero.slick("slickNext");
                },
                goToSlide: function (e) {
                    this.$hero.slick("slickGoTo", e);
                },
                pause: function () {
                    this.$hero.data("autoplay") && this.$hero.slick("slickPause");
                },
                play: function () {
                    this.$hero.data("autoplay") && this.$hero.slick("slickPlay");
                },
                destroy: function () {
                    this.$hero.off(this.namespace),
                        this.$heroContent.off(this.namespace),
                        this.$heroPause.off(this.namespace),
                        this.$wrapper.off(this.namespace),
                        this.$heroControlsArrow.off(this.namespace),
                        this.$heroAdapt.off(this.namespace),
                        this.$hero.slick("unslick");
                },
            })),
            o
        );
    })()),
    (window.Modals = (function () {
        var e = function (e, t, i) {
            var n = { close: ".js-modal-close", open: ".js-modal-open-" + t, openClass: "modal--is-active" };
            if (((this.$modal = $("#" + e)), !this.$modal.length)) return !1;
            (this.nodes = { $body: $("body") }), (this.config = $.extend(n, i)), (this.modalIsOpen = !1), (this.$focusOnOpen = this.config.focusOnOpen ? $(this.config.focusOnOpen) : this.$modal), this.init();
        };
        return (
            (e.prototype.init = function () {
                $(this.config.open).attr("aria-expanded", "false"), $(this.config.open).on("click", $.proxy(this.open, this)), this.$modal.find(this.config.close).on("click", $.proxy(this.close, this));
            }),
            (e.prototype.open = function (e) {
                var t = !1;
                if (!this.modalIsOpen) {
                    if ((e ? e.preventDefault() : (t = !0), e && e.stopPropagation && (e.stopPropagation(), (this.$activeSource = $(e.currentTarget))), this.modalIsOpen && !t)) return this.close();
                    this.$modal.prepareTransition().addClass(this.config.openClass),
                        this.nodes.$body.addClass(this.config.openClass),
                        (this.modalIsOpen = !0),
                        slate.a11y.trapFocus({ $container: this.$modal, namespace: "modal_focus", $elementToFocus: this.$focusOnOpen }),
                        this.$activeSource && this.$activeSource.attr("aria-expanded") && this.$activeSource.attr("aria-expanded", "true"),
                        this.bindEvents();
                }
            }),
            (e.prototype.close = function () {
                this.modalIsOpen &&
                    ($(document.activeElement).trigger("blur"),
                    this.$modal.prepareTransition().removeClass(this.config.openClass),
                    this.nodes.$body.removeClass(this.config.openClass),
                    (this.modalIsOpen = !1),
                    slate.a11y.removeTrapFocus({ $container: this.$modal, namespace: "modal_focus" }),
                    this.$activeSource && this.$activeSource.attr("aria-expanded") && this.$activeSource.attr("aria-expanded", "false").focus(),
                    this.unbindEvents());
            }),
            (e.prototype.bindEvents = function () {
                this.nodes.$body.on(
                    "keyup.modal",
                    $.proxy(function (e) {
                        27 === e.keyCode && this.close();
                    }, this)
                );
            }),
            (e.prototype.unbindEvents = function () {
                this.nodes.$body.off(".modal");
            }),
            e
        );
    })()),
    (window.Meganav = (function () {
        var e = function (e) {
            this.cache = { $document: $(document), $page: $(".page-element") };
            var t = {
                $meganavs: $(".meganav"),
                $megaNav: $(".meganav__nav"),
                $meganavToggle: $(".meganav-toggle"),
                $meganavDropdownContainers: $(".site-nav__dropdown-container"),
                $meganavToggleThirdLevel: $(".meganav__link-toggle"),
                $meganavLinkSecondLevel: $(".meganav__link--second-level"),
                $meganavLinkThirdLevel: $(".meganav__link--third-level"),
                $meganavDropdownThirdLevel: $(".site-nav__dropdown--third-level"),
                isOpen: !1,
                preventDuplicates: !1,
                closeOnPageClick: !1,
                closeThirdLevelOnBlur: !1,
                activeClass: "meganav--active",
                drawerClass: "meganav--drawer",
                meganavDropdown: ".site-nav__dropdown",
                meganavLinkClass: "meganav__link",
                drawerToggleClass: "drawer__nav-toggle-btn",
                drawerNavItem: ".drawer__nav-item",
                navCollectionClass: "meganav__nav--collection",
                secondLevelClass: "meganav__link--second-level",
                thirdLevelClass: "meganav__link-toggle",
                thirdLevelContainerClass: "site-nav__dropdown--third-level",
                noAnimationClass: "meganav--no-animation",
            };
            (this.config = $.extend(t, e)), this.init();
        };
        return (
            (e.prototype.init = function () {
                this.config.$meganavToggle.on("click", $.proxy(this.requestMeganav, this)), this.config.closeThirdLevelOnBlur && this.config.$meganavLinkThirdLevel.on("blur", $.proxy(this.closeThirdLevelMenu, this));
            }),
            (e.prototype.requestMeganav = function (e) {
                var t;
                e && e.preventDefault(), e && e.stopPropagation && e.stopPropagation();
                var i = $(e.currentTarget),
                    n = this.config.isOpen,
                    a = i.hasClass(this.config.thirdLevelClass);
                if (
                    ((t = i.hasClass(this.config.drawerToggleClass) ? i.closest(this.config.drawerNavItem).children("." + this.config.drawerClass) : i.siblings(this.config.meganavDropdown)), i.hasClass(this.config.activeClass) && i.is("a"))
                )
                    window.location = i.attr("href");
                else {
                    if ((!a && this.config.preventDuplicates && this.close(), t.hasClass(this.config.drawerClass))) {
                        var o = "true" === i.attr("aria-expanded");
                        i.toggleClass(this.config.activeClass).attr("aria-expanded", !o), t.stop().slideToggle(200);
                    } else i.addClass(this.config.activeClass).attr("aria-expanded", "true"), this.open(i, t, n);
                    this.bindEvents(), (this.config.isOpen = !0);
                    var s = i.next();
                    s.find(this.config.$megaNav).hasClass(this.config.navCollectionClass) && this.updateThirdLevelContainerWidth(i, s);
                }
            }),
            (e.prototype.updateThirdLevelContainerWidth = function (e, t) {
                var i = t.find(this.config.$meganavDropdownThirdLevel);
                i.length &&
                    $.each(
                        i,
                        function (e, t) {
                            var i = $(t),
                                n = i.find("li:last-child");
                            this.updateContainerWidth(i, n);
                        }.bind(this)
                    );
            }),
            (e.prototype.updateContainerWidth = function (e, t) {
                var i = e[0].getBoundingClientRect(),
                    n = t[0].getBoundingClientRect();
                if (!(n.left < i.right)) {
                    var a = i.width,
                        o = (n.left + a - i.left) / a,
                        s = 20 * o;
                    e.width(s + "%")
                        .find("li")
                        .css("width", 100 / o + "%");
                }
            }),
            (e.prototype.open = function (e, t, i) {
                var n = e.hasClass(this.config.thirdLevelClass);
                t.addClass(this.config.activeClass), n && this.toggleSubNav(e, t), i && t.addClass(this.config.noAnimationClass);
            }),
            (e.prototype.toggleSubNav = function (e) {
                this.removeMenuActiveState(),
                    e.addClass(this.config.activeClass).attr("aria-expanded", "true").siblings(this.config.$meganavDropdownThirdLevel).addClass(this.config.activeClass),
                    e.parent().addClass(this.config.activeClass);
            }),
            (e.prototype.close = function (e, t) {
                this.config.preventDuplicates
                    ? (this.config.$meganavs.removeClass([this.config.activeClass, this.config.noAnimationClass].join(" ")),
                      this.config.$meganavToggle.removeClass(this.config.activeClass).attr("aria-expanded", "false"),
                      this.config.$meganavDropdownContainers.removeClass(this.config.activeClass))
                    : ($("#" + t.attr("aria-controls")).removeClass([this.config.activeClass, this.config.noAnimationClass].join(" ")), t.removeClass(this.config.activeClass).attr("aria-expanded", "false"));
                this.unbindEvents(), (this.config.isOpen = !1);
            }),
            (e.prototype.closeThirdLevelMenu = function (e) {
                $(e.currentTarget).parent().is(":last-child") &&
                    this.config.$meganavLinkSecondLevel.one(
                        "focus.meganav",
                        $.proxy(function () {
                            this.removeMenuActiveState();
                        }, this)
                    );
            }),
            (e.prototype.removeMenuActiveState = function () {
                var e = [this.config.activeClass, this.config.noAnimationClass];
                this.config.$meganavToggleThirdLevel.removeClass(e.join(" ")).attr("aria-expanded", "false"),
                    this.config.$meganavDropdownThirdLevel.removeClass(e.join(" ")),
                    this.config.$meganavDropdownContainers.removeClass(this.config.activeClass);
            }),
            (e.prototype.bindEvents = function () {
                this.config.closeOnPageClick &&
                    (this.cache.$page.on("click.meganav", $.proxy(this.close, this)),
                    this.config.$meganavs.on(
                        "click.meganav",
                        function (e) {
                            var t = $(e.currentTarget).hasClass(this.config.activeClass) && $(e.currentTarget).hasClass(this.config.thirdLevelContainerClass),
                                i = $(e.target).hasClass(this.config.meganavLinkClass) && $(e.target).hasClass(this.config.secondLevelClass);
                            t || i || this.removeMenuActiveState(), e.stopImmediatePropagation();
                        }.bind(this)
                    ),
                    this.cache.$document.on(
                        "keyup.meganav",
                        $.proxy(function (e) {
                            27 === e.keyCode && (this.config.$meganavToggle.filter("." + this.config.activeClass).focus(), this.close());
                        }, this)
                    ));
            }),
            (e.prototype.unbindEvents = function () {
                this.config.closeOnPageClick &&
                    (this.cache.$page.off(".meganav"), this.config.$meganavs.off(".meganav"), this.cache.$document.off(".meganav"), this.config.$meganavLinkSecondLevel.off(".meganav"), this.config.$meganavLinkThirdLevel.off(".meganav"));
            }),
            e
        );
    })()),
    (window.QtySelector = (function () {
        var e = function (e) {
            (this.cache = {
                $body: $("body"),
                $subtotal: $("#CartSubtotal"),
                $discountTotal: $("#cartDiscountTotal"),
                $cartTable: $(".cart-table"),
                $cartTemplate: $("#CartProducts"),
                $cartFooter: $("#CartFooter"),
                $cartFooterTemplate: $("#CartFooterTemplate"),
            }),
                (this.settings = { loadingClass: "js-qty--is-loading", isCartTemplate: this.cache.$body.hasClass("template-cart"), minQty: this.cache.$body.hasClass("template-cart") ? 0 : 1 }),
                (this.$el = e),
                this.qtyUpdateTimeout,
                this.createInputs(),
                this.bindEvents();
        };
        return (
            (e.prototype.createInputs = function () {
                var e = this.$el,
                    t = { value: e.val(), key: e.attr("id"), name: e.attr("name"), line: e.attr("data-line") },
                    i = $("#QuantityTemplate").html(),
                    n = Handlebars.compile(i);
                (this.$wrapper = $(n(t)).insertBefore(e)), e.remove();
            }),
            (e.prototype.validateAvailability = function (e, t) {
                var i = theme.cartObject.items[e - 1],
                    n = i.handle,
                    a = i.id,
                    o = {
                        type: "GET",
                        url: "/products/" + n + ".js",
                        dataType: "json",
                        success: $.proxy(function (i) {
                            this.validateAvailabilityCallback(e, t, a, i);
                        }, this),
                    };
                $.ajax(o);
            }),
            (e.prototype.validateAvailabilityCallback = function (e, t, i, n) {
                for (var a = !0, o = 0; o < n.variants.length; o++) {
                    var s = n.variants[o];
                    if (s.id === i) break;
                }
                null !== s.inventory_management &&
                    "deny" === s.inventory_policy &&
                    s.inventory_quantity < t &&
                    (theme.Notify.open("error", theme.strings.noStockAvailable, !0), this.$wrapper.find(".js-qty__input").val(s.inventory_quantity), (a = !1), this.$wrapper.removeClass(this.settings.loadingClass)),
                    a && this.updateItemQuantity(e, t);
            }),
            (e.prototype.validateQty = function (e) {
                return (parseFloat(e) !== parseInt(e, 10) || isNaN(e)) && (e = 1), parseInt(e, 10);
            }),
            (e.prototype.adjustQty = function (e) {
                var t = $(e.currentTarget),
                    i = t.siblings(".js-qty__input"),
                    n = this.validateQty(i.val()),
                    a = i.attr("data-line");
                t.hasClass("js-qty__adjust--minus") ? (n -= 1) <= this.settings.minQty && (n = this.settings.minQty) : (n += 1),
                    this.settings.isCartTemplate ? (t.parent().addClass(this.settings.loadingClass), this.updateCartItemPrice(a, n)) : i.val(n);
            }),
            (e.prototype.bindEvents = function () {
                this.$wrapper.find(".js-qty__adjust").on("click", $.proxy(this.adjustQty, this)),
                    this.$wrapper.on("click", ".js-qty__input", function () {
                        this.setSelectionRange(0, this.value.length);
                    }),
                    this.settings.isCartTemplate &&
                        this.$wrapper.on(
                            "change",
                            ".js-qty__input",
                            $.proxy(function (e) {
                                var t = $(e.currentTarget),
                                    i = t.attr("data-line"),
                                    n = this.validateQty(t.val());
                                t.parent().addClass(this.settings.loadingClass), this.updateCartItemPrice(i, n);
                            }, this)
                        );
            }),
            (e.prototype.updateCartItemPrice = function (e, t) {
                clearTimeout(this.qtyUpdateTimeout),
                    (this.qtyUpdateTimeout = setTimeout(
                        $.proxy(function () {
                            this.validateAvailability(e, t);
                        }, this),
                        200
                    ));
            }),
            (e.prototype.updateItemQuantity = function (e, t) {
                var i = {
                    type: "POST",
                    url: "/cart/change.js",
                    data: "quantity=" + t + "&line=" + e,
                    dataType: "json",
                    success: $.proxy(function (e) {
                        this.updateCartItemCallback(e);
                    }, this),
                };
                $.ajax(i);
            }),
            (e.prototype.updateCartItemCallback = function (t) {
                if (0 !== t.item_count) {
                    theme.cartObject = t;
                    var i,
                        n,
                        a = [],
                        o = {},
                        s = $("#CartProductTemplate").html(),
                        r = Handlebars.compile(s);
                    $.each(t.items, function (e, t) {
                        if (
                            ((n = null === t.image ? "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif" : t.image.replace(/(\.[^.]*)$/, "_240x240$1").replace("http:", "")),
                            null !== t.properties &&
                                $.each(t.properties, function (e, i) {
                                    ("_" !== e.charAt(0) && i) || delete t.properties[e];
                                }),
                            0 !== t.line_level_discount_allocations.length)
                        )
                            for (var i in t.line_level_discount_allocations) {
                                var s = t.line_level_discount_allocations[i].amount;
                                t.line_level_discount_allocations[i].formattedAmount = theme.Currency.formatMoney(s, theme.moneyFormat);
                            }
                        var r = null;
                        t.unit_price_measurement &&
                            (r = {
                                addRefererenceValue: 1 !== t.unit_price_measurement.reference_value,
                                price: theme.Currency.formatMoney(t.unit_price, theme.moneyFormat),
                                reference_value: t.unit_price_measurement.reference_value,
                                reference_unit: t.unit_price_measurement.reference_unit,
                            }),
                            (o = {
                                key: t.key,
                                line: e + 1,
                                url: t.url,
                                img: n,
                                name: t.product_title,
                                variation: t.variant_title,
                                sellingPlanAllocation: t.selling_plan_allocation,
                                properties: t.properties,
                                itemQty: t.quantity,
                                price: theme.Currency.formatMoney(t.price, theme.moneyFormat),
                                vendor: t.vendor,
                                unitPrice: r,
                                linePrice: theme.Currency.formatMoney(t.final_line_price, theme.moneyFormat),
                                originalLinePrice: theme.Currency.formatMoney(t.original_line_price, theme.moneyFormat),
                                discounts: t.line_level_discount_allocations,
                                discountsApplied: 0 !== t.line_level_discount_allocations.length,
                            }),
                            a.push(o);
                    }),
                        (i = { items: a }),
                        this.cache.$cartTemplate.empty().append(r(i)),
                        this.updateCartFooter(t),
                        this.cache.$cartTable.find('input[type="number"]').each(function (t, i) {
                            new e($(i));
                        }),
                        slate.a11y.pageLinkFocus(this.cache.$cartTable);
                } else location.reload();
            }),
            (e.prototype.updateCartFooter = function (e) {
                if (0 !== e.cart_level_discount_applications.length)
                    for (var t in e.cart_level_discount_applications) {
                        var i = e.cart_level_discount_applications[t].total_allocated_amount;
                        e.cart_level_discount_applications[t].formattedAmount = theme.Currency.formatMoney(i, theme.moneyFormat);
                    }
                var n = this.cache.$cartFooterTemplate.html(),
                    a = Handlebars.compile(n),
                    o = { totalPrice: theme.Currency.formatMoney(e.total_price, theme.moneyFormat), cartDiscounts: e.cart_level_discount_applications, cartDiscountsApplied: 0 !== e.cart_level_discount_applications.length };
                this.cache.$cartFooter.empty().append(a(o));
            }),
            e
        );
    })()),
    (window.AjaxCart = (function () {
        var e = function (e) {
            (this.cache = { $cartIconIndicator: $(".site-header__cart-indicator") }), (this.$form = e), this.eventListeners();
        };
        return (

          
            (e.prototype.eventListeners = function () {
                this.$form.length && this.$form.on("submit", $.proxy(this.addItemFromForm, this));
            }),
            (e.prototype.addItemFromForm = function (e) {
                e.preventDefault();
                var t = {
                    type: "POST",
                    url: "/cart/add.js",
                    data: this.$form.serialize(),
                    dataType: "json",
                    success: $.proxy(function (e) {
                        this.success(e);
                    }, this),
                    error: $.proxy(function (e, t) {
                        this.error(e, t);
                    }, this),
                };
                $.ajax(t);
            }),
            (e.prototype.success = function () {
                theme.Notify.open("success", !1, !0), this.cache.$cartIconIndicator.removeClass("hide");
                 myfunction();
            }),
            (e.prototype.error = function (e) {
                var t = JSON.parse(e.responseText);
                t.message && theme.Notify.open("error", t.description, !0);
            }),
            e
        );
    })()),
    (window.Notify = (function () {
        var e = function () {
            (this.cache = {
                $scrollParent: $("html").add("body"),
                $notificationSuccess: $("#NotificationSuccess"),
                $notificationSuccessLink: $("#NotificationSuccess").find("a"),
                $notificationError: $("#NotificationError"),
                $notificationPromo: $("#NotificationPromo"),
                $notificationClose: $(".notification__close"),
                $notificationErrorMessage: $(".notification__message--error"),
            }),
                (this.settings = { notifyActiveClass: "notification--active", closeTimer: 5e3, promoKeyName: "promo-" + this.cache.$notificationPromo.data("text") }),
                this.notifyTimer,
                (this.$lastFocusedElement = null),
                (this.isLocalStorageSupported = (function () {
                    if (window.self !== window.top) return !1;
                    try {
                        var e = window.sessionStorage;
                        return e.setItem("test", "1"), e.removeItem("test"), !0;
                    } catch (e) {
                        return !1;
                    }
                })()),
                this.cache.$notificationClose.on("click", this.close.bind(this)),
                this.showPromo(),
                this.adaptNotification();
        };
        return (
            (e.prototype.open = function (e, t, i) {
                this.close(),
                    "success" === e
                        ? (this.cache.$notificationSuccess.attr("aria-hidden", !1).addClass(this.settings.notifyActiveClass),
                          (this.$lastFocusedElement = $(document.activeElement)),
                          this.cache.$notificationSuccess.one(
                              "TransitionEnd webkitTransitionEnd transitionend oTransitionEnd",
                              $.proxy(function () {
                                  slate.a11y.pageLinkFocus(this.cache.$notificationSuccessLink);
                              }, this)
                          ),
                          this.cache.$scrollParent.hasClass("no-csstransitions") && slate.a11y.pageLinkFocus(this.cache.$notificationSuccessLink))
                        : (this.cache.$notificationErrorMessage.html(t), this.cache.$notificationError.attr("aria-hidden", !1).addClass(this.settings.notifyActiveClass)),
                    i && (clearTimeout(this.notifyTimer), (this.notifyTimer = setTimeout(this.close.bind(this), this.settings.closeTimer)));
            }),
            (e.prototype.close = function (e) {
                e && "NotificationPromoClose" === $(e.currentTarget).attr("id") && this.isLocalStorageSupported && localStorage.setItem(this.settings.promoKeyName, "hidden"),
                    this.$lastFocusedElement && this.cache.$notificationSuccessLink.is(":focus") && slate.a11y.pageLinkFocus(this.$lastFocusedElement),
                    this.cache.$notificationSuccess.attr("aria-hidden", !0).removeClass(this.settings.notifyActiveClass),
                    this.cache.$notificationError.attr("aria-hidden", !0).removeClass(this.settings.notifyActiveClass),
                    this.cache.$notificationPromo.attr("aria-hidden", !0).removeClass(this.settings.notifyActiveClass),
                    (this.$lastFocusedElement = null);
            }),
            (e.prototype.showPromo = function (e) {
                e && this.initCache(), (this.isLocalStorageSupported && "hidden" === localStorage[this.settings.promoKeyName]) || this.cache.$notificationPromo.attr("aria-hidden", !1).addClass(this.settings.notifyActiveClass);
            }),
            (e.prototype.adaptNotification = function () {
                var e = $(".hero").data("adapt-height"),
                    t = $("#NotificationPromo"),
                    i = t.children(".notification__inner");
                t.length && (t.toggleClass("notification-adapt page-width", !0 === e), i.toggleClass("page-width", !1 === e));
            }),
            e
        );
    })()),
    (theme.Maps = (function () {
        var e = {
                zoom: 14,
                styles: [
                    { featureType: "water", elementType: "geometry", stylers: [{ color: "#cacaca" }, { lightness: 17 }] },
                    { featureType: "landscape", elementType: "geometry", stylers: [{ color: "#e1e1e1" }, { lightness: 20 }] },
                    { featureType: "road.highway", elementType: "geometry.fill", stylers: [{ color: "#ffffff" }, { lightness: 17 }] },
                    { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ color: "#ffffff" }, { lightness: 29 }, { weight: 0.2 }] },
                    { featureType: "road.arterial", elementType: "geometry", stylers: [{ color: "#ffffff" }, { lightness: 18 }] },
                    { featureType: "road.local", elementType: "geometry", stylers: [{ color: "#ffffff" }, { lightness: 16 }] },
                    { featureType: "poi", elementType: "geometry", stylers: [{ color: "#e1e1e1" }, { lightness: 21 }] },
                    { featureType: "poi.park", elementType: "geometry", stylers: [{ color: "#bbbbbb" }, { lightness: 21 }] },
                    { elementType: "labels.text.stroke", stylers: [{ visibility: "on" }, { color: "#ffffff" }, { lightness: 16 }] },
                    { elementType: "labels.text.fill", stylers: [{ saturation: 36 }, { color: "#333333" }, { lightness: 40 }] },
                    { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
                    { featureType: "transit", elementType: "geometry", stylers: [{ color: "#f2f2f2" }, { lightness: 19 }] },
                    { featureType: "administrative", elementType: "geometry.fill", stylers: [{ color: "#fefefe" }, { lightness: 20 }] },
                    { featureType: "administrative", elementType: "geometry.stroke", stylers: [{ color: "#fefefe" }, { lightness: 17 }, { weight: 1.2 }] },
                ],
            },
            t = null,
            i = [];
        function n(e) {
            theme.$currentMapContainer = this.$container = $(e);
            var n = this.$container.data("api-key");
            if ("string" == typeof n && "" !== n)
                if ("loaded" === t) {
                    var a = this;
                    0 === $('script[src*="' + n + '&"]').length
                        ? $.getScript("https://maps.googleapis.com/maps/api/js?key=" + n).then(function () {
                              (t = "loaded"), a.createMap();
                          })
                        : this.createMap();
                } else
                    i.push(this),
                        "loading" !== t &&
                            ((t = "loading"),
                            void 0 === window.google &&
                                $.getScript("https://maps.googleapis.com/maps/api/js?key=" + n).then(function () {
                                    (t = "loaded"),
                                        $.each(i, function (e, t) {
                                            t.createMap();
                                        });
                                }));
        }
        return (
            (n.prototype = _.assignIn({}, n.prototype, {
                createMap: function () {
                    var t = this.$container.find(".map-section__container");
                    return (function (e) {
                        var t = $.Deferred(),
                            i = new google.maps.Geocoder(),
                            n = e.data("address-setting");
                        return (
                            i.geocode({ address: n }, function (e, i) {
                                i !== google.maps.GeocoderStatus.OK && t.reject(i), t.resolve(e);
                            }),
                            t
                        );
                    })(t)
                        .then(
                            function (i) {
                                var n = { zoom: e.zoom, styles: e.styles, center: i[0].geometry.location, draggable: !1, clickableIcons: !1, scrollwheel: !1, disableDoubleClickZoom: !0, disableDefaultUI: !0 },
                                    a = (this.map = new google.maps.Map(t[0], n)),
                                    o = (this.center = a.getCenter()),
                                    s = t.data("enable-pin"),
                                    r = {
                                        path:
                                            "M57.7,0C25.8,0,0,25.8,0,57.7C0,89.5,50,170,57.7,170s57.7-80.5,57.7-112.3C115.3,25.8,89.5,0,57.7,0z M57.7,85 c-14.9,0-27-12.1-27-27c0-14.9,12.1-27,27-27c14.9,0,27,12.1,27,27C84.7,72.9,72.6,85,57.7,85z",
                                        fillColor: t.data("marker-color"),
                                        fillOpacity: 0.9,
                                        scale: 0.2,
                                        strokeWeight: 0,
                                    };
                                new google.maps.Marker({ map: a, position: o, icon: r, visible: s });
                                google.maps.event.addDomListener(
                                    window,
                                    "resize",
                                    $.debounce(250, function () {
                                        google.maps.event.trigger(a, "resize"), a.setCenter(o);
                                    })
                                );
                            }.bind(this)
                        )
                        .fail(function () {
                            var e;
                            switch (status) {
                                case "ZERO_RESULTS":
                                    e = theme.strings.addressNoResults;
                                    break;
                                case "OVER_QUERY_LIMIT":
                                    e = theme.strings.addressQueryLimit;
                                    break;
                                default:
                                    e = theme.strings.addressError;
                            }
                            if (Shopify.designMode) {
                                var i = t.parents(".map-section");
                                i.addClass("page-width map-section--load-error"),
                                    i.find(".map-section__content-wrapper").remove(),
                                    i.find(".map-section__wrapper").html('<div class="errors text-center" style="width: 100%;">' + e + "</div>");
                            }
                        });
                },
                onUnload: function () {
                    void 0 !== window.google && google.maps.event.clearListeners(this.map, "resize");
                },
            })),
            n
        );
    })()),
    (theme.stickyHeader = (function () {
        var e = { searchCartWrapper: "#SiteNavSearchCart", stickyNavSearchCart: "#StickyNavSearchCart", stickyNavWrapper: "#StickNavWrapper", stickyBar: "#StickyBar" },
            t = { lastScroll: 0, navClass: "sticky--active", openTransitionClass: "sticky--open", closeTransitionClass: "sticky--close" },
            i = {};
        function n() {
            var n = i.$window.scrollTop(),
                a = $(e.stickyNavWrapper),
                o = a.offset().top + a.height() + 10;
            n < t.lastScroll && (o = a.offset().top),
                n > o
                    ? (function () {
                          if (t.isActive) return;
                          (t.isActive = !0),
                              i.$stickyBar.addClass(t.navClass),
                              setTimeout(function () {
                                  i.$stickyBar.addClass(t.openTransitionClass);
                              }, 0);
                      })()
                    : (function () {
                          if (!t.isActive) return;
                          i.$stickyBar.removeClass(t.openTransitionClass).removeClass(t.navClass), (t.isActive = !1);
                      })(),
                (t.lastScroll = n);
        }
        return {
            init: function () {
                (i = { $window: $(window), $siteNavSearchCart: $(e.searchCartWrapper), $stickyBar: $(e.stickyBar) }),
                    (t.isActive = !1),
                    i.$siteNavSearchCart.contents().length && i.$siteNavSearchCart.contents().clone().appendTo($(e.stickyNavSearchCart)),
                    i.$window.on("scroll.stickynav", $.throttle(15, n));
            },
            unload: function () {
                $(window).off(".stickynav");
            },
        };
    })()),
    (theme.headerNav = (function () {
        var e = { siteNav: "#SiteNav", siteNavCompressed: "#SiteNavCompressed", siteNavParent: "#SiteNavParent", siteNavItem: ".site-nav__item", stickyNavWrapper: "#StickNavWrapper", stickyNav: "#StickyNav" },
            t = {
                lastScroll: 0,
                isActive: !1,
                navClass: "sticky--active",
                openTransitionClass: "sticky--open",
                closeTransitionClass: "sticky--close",
                searchInputClass: "site-header__search-input",
                searchSubmitClass: "site-header__search-submit",
                searchInnerActiveClass: "search-header__search-inner--active",
            };
        function i() {
            var t = 0,
                i = $(e.siteNavParent).width();
            $(e.stickyNavWrapper).height($(e.stickyNav).height()),
                $(e.siteNav).removeClass("hide"),
                $(e.siteNavItem).each(function (e, i) {
                    t += $(i).width();
                }),
                t > i ? ($(e.siteNav).addClass("hide"), $(e.siteNavCompressed).removeClass("hide")) : ($(e.siteNav).removeClass("hide"), $(e.siteNavCompressed).addClass("hide"));
        }
        return {
            init: function () {
                i(),
                    new window.Meganav({ $meganavs: $(".site-nav__dropdown"), $meganavToggle: $(".site-nav__link-toggle"), preventDuplicates: !0, closeOnPageClick: !0, closeThirdLevelOnBlur: !0 }),
                    new window.Meganav({ $meganavs: $(".meganav--index"), $meganavToggle: $(".index__meganav-toggle") }),
                    new window.Meganav({ $meganavs: $(".meganav--drawer"), $meganavToggle: $(".drawer__meganav-toggle") }),
                    $(".site-header__search").each(function (e, i) {
                        var n = $(i),
                            a = n.find("." + t.searchInputClass),
                            o = n.find("." + t.searchSubmitClass);
                        a.add(o).on("focus blur", function () {
                            n.toggleClass("active-form");
                        }),
                            o.on("mousedown", function () {
                                n.hasClass("active-form") && n.submit();
                            });
                    }),
                    window.matchMedia("(min-width: 750px)").matches && $(window).on("load", i),
                    $(window).on("resize.headernav", $.debounce(250, i));
            },
            unload: function () {
                $(window).off(".stickynav");
            },
        };
    })()),
    (theme.customerTemplates = (function () {
        function e() {
            $("#RecoverPasswordForm").toggleClass("hide"), $("#CustomerLoginForm").toggleClass("hide");
        }
        return {
            init: function () {
                var t;
                "#recover" === window.location.hash && e(),
                    $("#RecoverPassword").on("click", function (t) {
                        t.preventDefault(), e();
                    }),
                    $("#HideRecoverPasswordLink").on("click", function (t) {
                        t.preventDefault(), e();
                    }),
                    $(".reset-password-success").length && $("#ResetSuccess").removeClass("hide"),
                    (t = $("#AddressNewForm")).length &&
                        (Shopify && new Shopify.CountryProvinceSelector("AddressCountryNew", "AddressProvinceNew", { hideElement: "AddressProvinceContainerNew" }),
                        $(".address-country-option").each(function () {
                            var e = $(this).data("form-id"),
                                t = "AddressCountry_" + e,
                                i = "AddressProvince_" + e,
                                n = "AddressProvinceContainer_" + e;
                            new Shopify.CountryProvinceSelector(t, i, { hideElement: n });
                        }),
                        $(".address-new-toggle").on("click", function () {
                            t.toggleClass("hide");
                        }),
                        $(".address-edit-toggle").on("click", function () {
                            var e = $(this).data("form-id");
                            $("#EditAddress_" + e).toggleClass("hide");
                        }),
                        $(".address-delete").on("click", function () {
                            var e = $(this),
                                t = e.data("address-url"),
                                i = e.data("confirm-message");
                            confirm(i || "Are you sure you wish to delete this address?") && Shopify.postLink(t, { parameters: { _method: "delete" } });
                        }));
            },
        };
    })()),
    (theme.HeaderSection = (function () {
        function e() {
            var e;
            theme.stickyHeader.init(),
                theme.headerNav.init(),
                (theme.Notify = new window.Notify()),
                (theme.NavDrawer = new window.Drawers("NavDrawer", "left")),
                (e = $(".drawer__search-input")),
                $(".drawer__search-submit").on("click", function (t) {
                    0 === e.val().length && (t.preventDefault(), e.focus());
                });
        }
        return (
            (e.prototype = _.assignIn({}, e.prototype, {
                onSelect: function () {
                    theme.Notify.adaptNotification();
                },
                onUnload: function () {
                    theme.stickyHeader.unload(), theme.headerNav.unload();
                },
            })),
            e
        );
    })()),
    (theme.Filters = (function () {
        var e = { filterSelection: "#SortTags", sortSelection: "#SortBy" };
        function t() {
            (this.$filterSelect = $(e.filterSelection)), (this.$sortSelect = $(e.sortSelection)), this.$filterSelect.on("change", this._onFilterChange.bind(this)), this.$sortSelect.on("change", this._onSortChange.bind(this));
        }
        return (
            (t.prototype = _.assignIn({}, t.prototype, {
                _onFilterChange: function () {
                    location.href = this.$filterSelect.val();
                },
                _onSortChange: function () {
                    (Shopify.queryParams.sort_by = this.$sortSelect.val()), Shopify.queryParams.page && delete Shopify.queryParams.page, (location.search = decodeURIComponent($.param(Shopify.queryParams)));
                },
                onUnload: function () {
                    this.$filterSelect.off("change", this._onFilterChange), this.$sortSelect.off("change", this._onSortChange);
                },
            })),
            t
        );
    })()),
    (theme.Product = (function () {
        var e = { smallBreakpoint: 750, productThumbIndex: 0, productThumbMax: 0, ajaxCart: !1, stockSetting: !1 };
        function t(t) {
            var i = (this.$container = $(t)),
                n = i.attr("data-section-id");
            (this.selectors = {
                originalSelectorId: "#ProductSelect-" + n,
                modal: "ProductModal",
                productZoomImage: "#ProductZoomImg",
                addToCart: "#AddToCart-" + n,
                productPrice: "#ProductPrice-" + n,
                comparePrice: "#ComparePrice-" + n,
                addToCartText: "#AddToCartText-" + n,
                SKU: ".variant-sku",
                productImageContainers: ".product__photo-container-" + n,
                productImageWrappers: ".product__photo-wrapper-" + n,
                productThumbContainers: ".product-single__thumbnail-item-" + n,
                productThumbsWrapper: ".product-single__thumbnails-" + n,
                productThumbs: ".product-single__thumbnail-" + n,
                saleTag: "#ProductSaleTag-" + n,
                productStock: "#ProductStock-" + n,
                singleOptionSelector: ".single-option-selector-" + n,
                shopifyPaymentButton: ".shopify-payment-button",
                unitPrice: "[data-unit-price]",
                unitPriceBaseUnit: "[data-unit-price-base-unit]",
                unitPriceContainer: "[data-unit-price-container]",
            }),
                (this.settings = $.extend({}, e, { sectionId: n, ajaxCart: i.data("ajax"), stockSetting: i.data("stock"), enableHistoryState: i.data("enable-history-state") || !1, namespace: ".product-" + n })),
                $("#ProductJson-" + n).html() && ((this.productSingleObject = JSON.parse($("#ProductJson-" + n).html())), this.addVariantInfo(), this.init());
        }
        return (
            (t.prototype = _.assignIn({}, t.prototype, {
                init: function () {
                    this._stringOverrides(),
                        this._initVariants(),
                        this._productZoomImage(),
                        this._productThumbSwitch(),
                        this._productThumbnailSlider(),
                        this._initQtySelector(),
                        this.settings.ajaxCart && (theme.AjaxCart = new window.AjaxCart($("#AddToCartForm-" + this.settings.sectionId)));
                },
                _stringOverrides: function () {
                    (window.productStrings = window.productStrings || {}), $.extend(theme.strings, window.productStrings);
                },
                addVariantInfo: function () {
                    if (this.productSingleObject && this.settings.stockSetting) for (var e = JSON.parse($("#VariantJson-" + this.settings.sectionId).html()), t = 0; t < e.length; t++) $.extend(this.productSingleObject.variants[t], e[t]);
                },
                _initVariants: function () {
                    var e = {
                        $container: this.$container,
                        enableHistoryState: this.settings.enableHistoryState,
                        product: this.productSingleObject,
                        singleOptionSelector: this.selectors.singleOptionSelector,
                        originalSelectorId: this.selectors.originalSelectorId,
                    };
                    (this.variants = new slate.Variants(e)),
                        this.$container.on("variantChange" + this.settings.namespace, this._updateVariantChange.bind(this)),
                        this.$container.on("variantPriceChange" + this.settings.namespace, this._updatePrice.bind(this)),
                        this.$container.on("variantSKUChange" + this.settings.namespace, this._updateSKU.bind(this)),
                        this.$container.on("variantImageChange" + this.settings.namespace, this._updateImages.bind(this));
                },
                _updateStock: function (e) {
                    if (this.settings.stockSetting) {
                        var t = $(this.selectors.productStock);
                        e && e.inventory_management
                            ? e.inventory_quantity < 10 && e.inventory_quantity > 0
                                ? t.html(theme.strings.stockAvailable.replace("1", e.inventory_quantity)).removeClass("hide")
                                : e.inventory_quantity <= 0 && e.incoming
                                ? t.html(theme.strings.willNotShipUntil.replace("[date]", e.next_incoming_date)).removeClass("hide")
                                : t.addClass("hide")
                            : t.addClass("hide");
                    }
                },
                _updateIncomingInfo: function (e) {
                    if (this.settings.stockSetting) {
                        var t = $(this.selectors.productStock);
                        e.incoming ? t.html(theme.strings.willBeInStockAfter.replace("[date]", e.next_incoming_date)).removeClass("hide") : t.addClass("hide");
                    }
                },
                _updateVariantChange: function (e) {
                    var t = e.variant,
                        i = { $addToCart: $(this.selectors.addToCart), $addToCartText: $(this.selectors.addToCartText) };
                    if (t) {
                        if (
                            (t.available
                                ? (i.$addToCart.removeClass("btn--sold-out").prop("disabled", !1), i.$addToCartText.html(theme.strings.addToCart), $(this.selectors.shopifyPaymentButton, this.$container).show(), this._updateStock(t))
                                : (i.$addToCart.prop("disabled", !0).addClass("btn--sold-out"), i.$addToCartText.html(theme.strings.soldOut), $(this.selectors.shopifyPaymentButton, this.$container).hide(), this._updateIncomingInfo(t)),
                            $(this.selectors.unitPriceContainer, this.$container).addClass("hide"),
                            t.unit_price_measurement)
                        ) {
                            var n = $(this.selectors.unitPrice, this.$container),
                                a = $(this.selectors.unitPriceBaseUnit, this.$container);
                            n.html(theme.Currency.formatMoney(t.unit_price, theme.moneyFormat)), a.html(this._getBaseUnit(t)), $(this.selectors.unitPriceContainer, this.$container).removeClass("hide");
                        }
                    } else i.$addToCart.prop("disabled", !0).removeClass("btn--sold-out"), i.$addToCartText.html(theme.strings.unavailable), $(this.selectors.shopifyPaymentButton, this.$container).hide(), this._updateStock();
                },
                _updatePrice: function (e) {
                    var t = e.variant;
                    t
                        ? ($(this.selectors.productPrice).html(theme.Currency.formatMoney(t.price, theme.moneyFormat)),
                          t.compare_at_price > t.price
                              ? ($(this.selectors.comparePrice).html(theme.Currency.formatMoney(t.compare_at_price, theme.moneyFormat)).removeClass("hide"), $(this.selectors.saleTag).removeClass("hide"))
                              : ($(this.selectors.comparePrice).addClass("hide"), $(this.selectors.saleTag).addClass("hide")))
                        : $(this.selectors.comparePrice).addClass("hide");
                },
                _getBaseUnit: function (e) {
                    return 1 === e.unit_price_measurement.reference_value ? e.unit_price_measurement.reference_unit : e.unit_price_measurement.reference_value + e.unit_price_measurement.reference_unit;
                },
                _updateSKU: function (e) {
                    var t = e.variant;
                    t && $(this.selectors.SKU).html(t.sku);
                },
                _updateImages: function (e) {
                    var t = e.variant;
                    if (t && t.featured_image) {
                        var i = t.featured_image.id;
                        this.switchProductImage(i), this.setActiveThumbnail(i);
                    }
                },
                switchProductImage: function (e) {
                    var t = $(this.selectors.productImageContainers + "[data-image-id='" + e + "']", this.$container);
                    $(this.selectors.productImageContainers + ":not([data-image-id='" + e + "'])", this.$container).addClass("hide"), t.removeClass("hide");
                },
                setActiveThumbnail: function (e) {
                    var t = $(this.selectors.productThumbContainers + "[data-image-id='" + e + "']", this.$container);
                    $(this.selectors.productThumbContainers + ":not([data-image-id='" + e + "'])", this.$container).removeClass("is-active"), t.addClass("is-active");
                    var i = $(this.selectors.productThumbsWrapper, this.$container);
                    if (i.hasClass("slick-initialized")) {
                        var n = i.slick("slickCurrentSlide"),
                            a = parseInt(t.attr("data-slick-index"));
                        n !== a && i.slick("slickGoTo", a, !1);
                    }
                },
                _productZoomImage: function () {
                    if ($(".product-single " + this.selectors.productImageContainers).length) {
                        var e = this;
                        $(this.selectors.productImageWrappers).on("click" + this.settings.namespace, function (t) {
                            t.preventDefault(), $(e.selectors.productZoomImage).attr("src", "").attr("src", $(this).attr("href"));
                        }),
                            (this.ProductModal = new window.Modals(this.selectors.modal, "product-modal")),
                            this.ProductModal.$modal.on("click" + this.settings.namespace, function (t) {
                                "IMG" !== t.target.nodeName && e.ProductModal.close();
                            });
                    }
                },
                _productThumbSwitch: function () {
                    if ($(this.selectors.productThumbs).length) {
                        var e = this;
                        $(this.selectors.productThumbs).on("click" + this.settings.namespace, function (t) {
                            t.preventDefault();
                            var i = $(this).parent().data("image-id");
                            e.setActiveThumbnail(i), e.switchProductImage(i);
                        });
                    }
                },
                _productThumbnailSlider: function () {
                    var e = $(this.selectors.productThumbsWrapper),
                        t = $(this.selectors.productThumbs);
                    if (t.length && t.length > 2) {
                        var i, n;
                        e.on("init" + this.settings.namespace, this._productSwipeInit.bind(this));
                        var a = window.sliderArrows || !1;
                        a &&
                            ((i = '<button type="button" class="slick-next"><span class="medium-up--hide">' + a.right + '</span><span class="small--hide">' + a.down + "</span></button>"),
                            (n = '<button type="button" class="slick-prev"><span class="medium-up--hide">' + a.left + '</span><span class="small--hide">' + a.up + "</span></button>")),
                            e.slick({
                                accessibility: !1,
                                arrows: !0,
                                dots: !1,
                                infinite: !1,
                                autoplay: !1,
                                slidesToShow: 3,
                                slidesToScroll: 3,
                                vertical: !0,
                                verticalSwiping: !0,
                                nextArrow: i,
                                prevArrow: n,
                                responsive: [{ breakpoint: this.settings.smallBreakpoint, settings: { vertical: !1, verticalSwiping: !1 } }],
                            }),
                            e.slick("slickGoTo", e.find(".is-active").attr("data-slick-index"), !0);
                    }
                },
                _productSwipeInit: function (e, t) {
                    (this.settings.productThumbIndex = t.currentSlide), (this.settings.productThumbMax = t.slideCount - 1);
                    var i = this;
                    $(this.selectors.productImageWrappers).on("swipeleft swiperight", function (e) {
                        "swipeleft" === e.type && i._goToNextThumbnail(),
                            "swiperight" === e.type && i._goToPrevThumbnail(),
                            $('.product-single__thumbnail-item[data-slick-index="' + i.settings.productThumbIndex + '"]')
                                .find(".product-single__thumbnail")
                                .trigger("click");
                    });
                },
                _goToNextThumbnail: function () {
                    this.settings.productThumbIndex++,
                        this.settings.productThumbIndex > this.settings.productThumbMax && (this.settings.productThumbIndex = 0),
                        $(this.selectors.productThumbsWrapper).slick("slickGoTo", this.settings.productThumbIndex, !0);
                },
                _goToPrevThumbnail: function () {
                    this.settings.productThumbIndex--,
                        this.settings.productThumbIndex < 0 && (this.settings.productThumbIndex = this.settings.productThumbMax),
                        $(this.selectors.productThumbsWrapper).slick("slickGoTo", this.settings.productThumbIndex, !0);
                },
                _initQtySelector: function () {
                    this.$container.find(".product-form__quantity").each(function (e, t) {
                        new QtySelector($(t));
                    });
                },
                onUnload: function () {
                    $(this.selectors.productImageWrappers).off(this.settings.namespace),
                        $(this.selectors.productThumbs).off(this.settings.namespace),
                        $(this.selectors.productThumbs).slick("unslick"),
                        this.ProductModal && this.ProductModal.$modal.off(this.settings.namespace);
                },
            })),
            t
        );
    })()),
    (theme.slideshows = {}),
    (theme.Slideshow = (function () {
        function e(e) {
            this.$container = $(e);
            var t = this.$container.attr("data-section-id");
            (this.slideshow = "#Slideshow-" + t), (theme.slideshows[this.slideshow] = new theme.Hero(this.slideshow));
        }
        return (
            (e.prototype = _.assignIn({}, e.prototype, {
                onUnload: function () {
                    theme.slideshows[this.slideshow].destroy();
                },
                onSelect: function () {
                    theme.slideshows[this.slideshow].pause(), theme.Notify.adaptNotification();
                },
                onDeselect: function () {
                    theme.slideshows[this.slideshow].play();
                },
                onBlockSelect: function (e) {
                    var t = $(".hero__slide--" + e.detail.blockId + ":not(.slick-cloned)").data("slick-index");
                    theme.slideshows[this.slideshow].pause(), theme.slideshows[this.slideshow].goToSlide(t);
                },
                onBlockDeselect: function () {
                    theme.slideshows[this.slideshow].play();
                },
            })),
            e
        );
    })()),
    (theme.Cart = (function () {
        var e = "#CartSpecialInstructions",
            t = ".cart__quantity",
            i = "cart--no-cookies";
        function n(e) {
            var t = (this.$container = $(e)),
                i = t.attr("data-section-id");
            (theme.cartObject = JSON.parse($("#CartJson-" + i).html())), this.init(t);
        }
        return (
            (n.prototype = _.assignIn({}, n.prototype, {
                init: function (e) {
                    this._initQtySelector(), this._initCartNote(), this._cookiesEnabled() || e.addClass(i);
                },
                _initQtySelector: function () {
                    $(t).each(function (e, t) {
                        new QtySelector($(t));
                    });
                },
                _initCartNote: function () {
                    if ($(e).length) {
                        var t,
                            i,
                            n = $(e),
                            a = n[0].offsetHeight - n[0].clientHeight;
                        n.on("keyup input", function () {
                            $(this)
                                .css("height", "auto")
                                .css("height", n[0].scrollHeight + a);
                        }),
                            n.on(
                                "change",
                                $.proxy(function () {
                                    (t = n.val()), (i = { type: "POST", url: "/cart/update.js", data: "note=" + this._attributeToString(t), dataType: "json" }), $.ajax(i);
                                }, this)
                            );
                    }
                },
                _attributeToString: function (e) {
                    return "string" != typeof e && "undefined" === (e = String(e)) && (e = ""), $.trim(e);
                },
                _cookiesEnabled: function () {
                    var e = navigator.cookieEnabled;
                    return e || ((document.cookie = "testcookie"), (e = -1 !== document.cookie.indexOf("testcookie"))), e;
                },
            })),
            n
        );
    })()),
    (theme.Quotes = (function () {
        function e(e) {
            (this.$container = $(e).on("init", this._a11y.bind(this))), this.$container.slick({ accessibility: !0, arrows: !1, dots: !0, draggable: !0, autoplay: !1 });
        }
        return (
            (e.prototype = _.assignIn({}, e.prototype, {
                _a11y: function (e, t) {
                    var i = t.$list,
                        n = this.$container.parent();
                    i.removeAttr("aria-live"),
                        n.on("focusin", function (e) {
                            n.has(e.target).length && i.attr("aria-live", "polite");
                        }),
                        n.on("focusout", function (e) {
                            n.has(e.target).length && i.removeAttr("aria-live");
                        });
                },
                _goToSlide: function (e) {
                    this.$container.slick("slickGoTo", e);
                },
                onUnload: function () {
                    delete this.$container;
                },
                onBlockSelect: function (e) {
                    var t = $(".quote__slide-wrapper--" + e.detail.blockId + ":not(.slick-cloned)").data("slick-index");
                    this._goToSlide(t);
                },
            })),
            e
        );
    })()),
    (theme.Video = (function () {
        var e,
            t,
            i = {
                promiseAPI: function () {
                    if (!e) {
                        var t = document.createElement("script");
                        t.src = "https://www.youtube.com/iframe_api";
                        var i = document.getElementsByTagName("script")[0];
                        i.parentNode.insertBefore(t, i),
                            (e = $.Deferred(function (e) {
                                (window.onYouTubeIframeAPIReady = e.resolve),
                                    setTimeout(function () {
                                        e.reject("Request for YouTube API timed out after 30 seconds.");
                                    }, 3e4);
                            }));
                    }
                    return e;
                },
                promisePlayer: function (e, t) {
                    return this.promiseAPI().then(function () {
                        return $.Deferred(function (i) {
                            void 0 === window.YT && i.reject("We're sorry, something went wrong. The YouTube API has not loaded correctly.");
                            var n = new YT.Player(e, t);
                            n.addEventListener("onReady", function () {
                                i.resolve(n);
                            }),
                                setTimeout(function () {
                                    i.reject("Request for YouTube player has timed out after 30 seconds.");
                                }, 3e4);
                        });
                    });
                },
            },
            n = {
                promiseAPI: function () {
                    return (
                        t ||
                            (t = $.Deferred(function (e) {
                                var t = document.createElement("script");
                                (t.src = "https://player.vimeo.com/api/player.js"),
                                    (t.onload = t.onreadystatechange = function () {
                                        (this.readyState && "complete" !== this.readyState) || e.resolve();
                                    });
                                var i = document.getElementsByTagName("script")[0];
                                i.parentNode.insertBefore(t, i),
                                    setTimeout(function () {
                                        e.reject("Request for Vimeo API timed out after 30 seconds.");
                                    }, 3e4);
                            })),
                        t
                    );
                },
                promisePlayer: function (e, t) {
                    return this.promiseAPI().then(function () {
                        return $.Deferred(function (i) {
                            void 0 === window.Vimeo && i.reject("We're sorry, something went wrong. The Vimeo API has not loaded correctly.");
                            var n = new window.Vimeo.Player(e, t);
                            setTimeout(function () {
                                i.reject("Request for Vimeo player has timed out after 30 seconds.");
                            }, 3e4),
                                n.ready().then(function () {
                                    i.resolve(n);
                                });
                        });
                    });
                },
            },
            a = ".video-section__load-player-button",
            o = ".video-section__player-close",
            s = ".video-section__player",
            r = ".video-section__cover",
            c = ".video-section__error",
            l = ".video-section__body-overlay",
            h = "body",
            d = "video-section--loaded",
            u = "video-section--error",
            p = "video-playing";
        function m(e) {
            this.$container = $(e);
            var t = this.$container.attr("data-section-id");
            (this.namespace = "." + t), this.onLoad();
        }
        return (
            (m.prototype = _.assignIn({}, m.prototype, {
                onLoad: function () {
                    this.$container.on("click", a, this._loadPlayer.bind(this)).on("click", o, this._closePlayer.bind(this)).on("click", l, this._closePlayer.bind(this));
                },
                _loadPlayer: function () {
                    var e,
                        t = this.$container,
                        i = $(s, t),
                        n = this.$container.attr("data-video-type");
                    return "youtube" === n ? (e = this._loadYoutubePlayer(i[0])) : "vimeo" === n && (e = this._loadVimeoPlayer(i[0])), e.then(this._onPlayerLoadReady.bind(this)).fail(this._onPlayerLoadError.bind(this));
                },
                _loadYoutubePlayer: function (e) {
                    return i.promisePlayer(e, { videoId: this.$container.attr("data-video-id"), ratio: 16 / 9, playerVars: { modestbranding: 1, autoplay: 1, showinfo: 0, rel: 0 } }).then(
                        function (e) {
                            this.player = e;
                        }.bind(this)
                    );
                },
                _loadVimeoPlayer: function (e) {
                    return n.promisePlayer(e, { id: this.$container.attr("data-video-id") }).then(
                        function (e) {
                            (this.player = e), this.player.play();
                        }.bind(this)
                    );
                },
                _onPlayerLoadReady: function () {
                    $(o, this.$container).show().focus(),
                        $(r, this.$container).addClass(d),
                        this.$container.addClass(d),
                        this._setScrollPositionValues(),
                        $(h).addClass(p),
                        $(document).on("keyup" + this.namespace, this._closeOnEscape.bind(this)),
                        $(window).on("resize" + this.namespace, this._setScrollPositionValues.bind(this)),
                        slate.a11y.trapFocus({ $container: this.$container, namespace: this.namespace });
                },
                _onPlayerLoadError: function (e) {
                    this.$container.addClass(u), $(c, this.$container).text(e);
                },
                _closeOnEscape: function (e) {
                    27 === e.keyCode && (this._closePlayer(), $(a, this.$container).focus());
                },
                _onScroll: function () {
                    var e = $(window).scrollTop();
                    (e > this.videoTop + 0.25 * this.videoHeight || e + this.windowHeight < this.videoBottom - 0.25 * this.videoHeight) && requestAnimationFrame(this._closePlayer.bind(this));
                },
                _setScrollPositionValues: function () {
                    (this.videoHeight = this.$container.outerHeight(!0)), (this.videoTop = this.$container.offset().top), (this.videoBottom = this.videoTop + this.videoHeight), (this.windowHeight = $(window).innerHeight());
                },
                _closePlayer: function () {
                    $(h).removeClass(p),
                        $(r, this.$container).removeClass(d),
                        this.$container.removeClass(d),
                        $(o, this.$container).hide(),
                        slate.a11y.removeTrapFocus({ $container: this.$container, namespace: this.namespace }),
                        "function" == typeof this.player.destroy ? this.player.destroy() : "function" == typeof this.player.unload && this.player.unload(),
                        $(document).off(this.namespace),
                        $(window).off(this.namespace);
                },
            })),
            m
        );
    })()),
    (theme.CollectionsList = (function () {
        function e(e) {
            var t = (this.$container = $(e));
            if (!t.is("[data-stretch-image]")) {
                var i = (this.namespace = "." + t.attr("data-section-id")),
                    n = this;
                n._collectionListFix(),
                    $(window).on(
                        "resize" + i,
                        $.debounce(250, function () {
                            n._collectionListFix();
                        })
                    );
            }
        }
        return (
            (e.prototype = _.assignIn({}, e.prototype, {
                onUnload: function () {
                    $(window).off(this.namespace);
                },
                _collectionListFix: function () {
                    var e = this.$container.find(".grid").data("number-rows"),
                        t = this.$container.find(".featured-card");
                    if (!t.is("[data-stretch-image]"))
                        for (var i = 0; i < e; i++) {
                            var n = 0,
                                a = 0,
                                o = t.filter("[data-row-number='" + (i + 1) + "']"),
                                s = o.find(".featured-card__header");
                            o.each(function () {
                                var e = $(this).find(".featured-card__title"),
                                    t = $(this).find(".featured-card__action"),
                                    i = $(this).find(".featured-card__image-wrapper"),
                                    o = e.outerHeight() + t.outerHeight() + 65,
                                    s = i.outerHeight();
                                o > a && (a = o), s > n && (n = s);
                            }),
                                s.outerHeight(a),
                                o.height(n + a + 40);
                        }
                },
            })),
            e
        );
    })()),
    (theme.ProductRecommendations = (function () {
        return function (e) {
            this.$container = $(e);
            var t = this.$container.data("baseUrl") + "?section_id=product-recommendations&product_id=" + this.$container.data("productId") + "&limit=6";
            $.get(t).then(
                function (e) {
                    var t = $(e).html();
                    "" !== t.trim() && this.$container.html(t);
                }.bind(this)
            );
        };
    })()),
    (theme.init = function () {
        theme.customerTemplates.init(),
            slate.rte.wrapTable(),
            slate.rte.iframeReset(),
            slate.a11y.pageLinkFocus($(window.location.hash)),
            $(".in-page-link").on("click", function (e) {
                slate.a11y.pageLinkFocus($(e.currentTarget.hash));
            }),
            $('a[href="#"]').on("click", function (e) {
                e.preventDefault();
            });
        var e = new theme.Sections();
        e.register("header", theme.HeaderSection),
            e.register("product", theme.Product),
            e.register("featured-product", theme.Product),
            e.register("collection-filters", theme.Filters),
            e.register("map", theme.Maps),
            e.register("slideshow", theme.Slideshow),
            e.register("cart", theme.Cart),
            e.register("quotes", theme.Quotes),
            e.register("video", theme.Video),
            e.register("collections-list", theme.CollectionsList),
            e.register("product-recommendations", theme.ProductRecommendations),
            $(window).on("load", theme.articleImages),
            theme.passwordModalInit(),
            theme.productCardImageLoadingAnimation();
    }),
    (theme.articleImages = function () {
        var e = $(".rte--indented-images");
        e.length &&
            e.find("img").each(function (t, i) {
                var n = $(i),
                    a = n.attr("style");
                (a && "float: none;" !== a) || (n.width() >= e.width() && n.parent("p").addClass("rte__image-indent"));
            });
    }),
    (theme.passwordModalInit = function () {
        var e = $("#LoginModal");
        e.length && ((theme.PasswordModal = new window.Modals("LoginModal", "login-modal", { focusOnOpen: "#Password" })), e.find(".errors").length && theme.PasswordModal.open());
    }),
    (theme.productCardImageLoadingAnimation = function () {
        var e = { image: "[data-image]", imagePlaceholder: "[data-image-placeholder]", imageWithPlaceholderWrapper: "[data-image-with-placeholder-wrapper]" },
            t = { hidden: "placeholder-background--hide" };
        $(document).on("lazyloaded", function (i) {
            var n = $(i.target);
            n.is(e.image) && n.closest(e.imageWithPlaceholderWrapper).find(e.imagePlaceholder).addClass(t.hidden);
        }),
        $(e.image + ".lazyloaded")
          .closest(e.imageWithPlaceholderWrapper)
          .find(e.imagePlaceholder)
          .addClass(t.hidden);
    }),
    $(theme.init);

  function myfunction() {

     var warr_value =  $(document).find("input[name='fav']:checked").attr('data-fianl');
     var warr_name =  $(document).find("input[name='fav']:checked").attr('data-war');
     var main_product_handle =  $(document).find("input[name='fav']:checked").attr('data-handle');
     var main_product_id = $('.itg_custom_discount').find(":selected").attr('value');
     var main_product_qty = $('.product-form__item--quantity').find("input#Quantity").val();
     var random_number = $(document).find("#randomNumber").val();

     if(warr_value != '' && warr_value != undefined){

        var fd = new FormData();
        fd.append("price",warr_value);
       
        var data = { updates: {} };
        data.updates[main_product_id] = 0;
        jQuery.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: data,
          dataType: 'json',
          success: function(suc) { 
            
            $(document).find(".custom_loader-bg").css("display", "flex");
            
            $.ajax({
              url: 'https://dev.shopifyexperthelp.com/app/project_custom_code/deluxe/warrantyanother.php',
              data: fd,
              contentType: false,
              processData: false,
              type: 'POST',
              success: function(res){
                 var respData = JSON.parse(res);
                if(respData['status'] == 1){
                   localStorage.removeItem("item_varaint");
                   var varid = respData['varid'];
                   var varprice = respData['varprice'];
                   localStorage.setItem('item_varaint', varid);
                     var extra = {
                        "id": varid,
                        "quantity": 1,
                        "properties": {
                          "Rno": random_number
                        }
                      }
                      jQuery.ajax({
                        type: 'POST',
                        url: '/cart/add.js',
                        data: extra,
                        dataType: 'json',
                        success: function() { 
                          var data = {
                            "id": main_product_id,
                            "quantity": main_product_qty,
                            "properties": {
                              "Warranty": warr_name,
                              "Rno": random_number
                            }
                          }
                          jQuery.ajax({
                            type: 'POST',
                            url: '/cart/add.js',
                            data: data,
                            dataType: 'json',
                            success: function() { 
                              //window.location.href = '/cart'; 
                              $(document).find(".custom_loader-bg").css("display", "none");
                              theme.Notify.open("success", !1, !0), this.cache.$cartIconIndicator.removeClass("hide");
                            }
                          });
                        }
                      });
                   }else{
                      localStorage.setItem(random_number, '');
                      alert('error');
                      return false;
                   }
                
                  }
            });
           
          },error: function(){
            //alert('error');
          }
        });
       
     }
  };

$(document).ready(function(){
  $("ul li.warranty_discount:first-child").find('input').attr( 'checked', true );
  
  $(".collection-sort__label.SortTags").click(function(){
    if ($('ul#SortTags.collection-sort__input').hasClass('act')) {
      $('ul#SortTags.collection-sort__input').removeClass('act');
    }else{
      $('ul#SortTags.collection-sort__input').addClass('act');
    }
  });


   function itgFilter(){
     var collection_url = $(document).find('.itg_filter_mndv').attr('data-url');
      var tag_list = '/';
       $(document).find('ul.itg_collection_sort li.active_box').each(function(index){
        if(index == 0){
          tag_list += $(this).attr('value');        	
        }else{
          tag_list += '+'+$(this).attr('value');
        }
     });
      collection_url +=tag_list;
      var searchParams = new URLSearchParams(window.location.search);
      var sort_by_data = searchParams.get('sort_by');
      if(sort_by_data == null){
        var obj = { Title: 'ChangeUrl', Url: collection_url };  
        history.pushState(obj, obj.Title, obj.Url);
        location.reload();
      }else{
         var obj = { Title: 'ChangeUrl', Url: collection_url+'?sort_by='+sort_by_data };  
    	 history.pushState(obj, obj.Title, obj.Url);
         location.reload();
      }
      
   }
  
   $(document).on('click','ul.itg_collection_sort li',function(e){
       if( $(this).hasClass('active_box')){
    	 $(this).removeClass('active_box');
       }else{    	
         $(this).addClass('active_box');
      }
      itgFilter();
   });


  $("#SortBy").click(function(){
    $('ul#SortTags.collection-sort__input').removeClass('act');
  });

    var proid = $(document).find("#product-single").attr('data-id');
    if(proid != undefined){
         $(document).find(".custom_loader-bg").css("display", "flex");
         var form_data = new FormData();
         form_data.append("proid", proid);
         $.ajax({
              type: 'POST',
              url: 'https://dev.shopifyexperthelp.com/app/project_custom_code/deluxe/single_product.php',
              data:form_data,
              contentType: false,
              cache: false,
              processData:false,
              success: function(response){
                var respData = JSON.parse(response);
                if(respData['status'] == 1){
                  $(document).find("#custom_server_varaint").html('');
                  var regionData = respData['alldata'];
                  $(document).find("#custom_server_varaint").html(regionData);
                  $(document).find(".custom_loader-bg").css("display", "none");
                  ajaxoption();
                }
              }
          });
      }

   function ajaxoption() {
     
        var warranty_value = $('.itg_custom_discount').find(":selected").attr('value');

        $(".itg_custom_discount > option").each(function() {
          
           var ths_value = $(this).attr('value');
           if(ths_value == warranty_value){
  
               var currency_symbol = $(document).find("body").attr('data-symbol');
               if(currency_symbol == '₹'){
                 var currency_symbol = 'Rs.';
               }else{
                 var currency_symbol = '$';
               }
               var warranty_price = ''
               var warranty_compare = parseFloat($(this).attr('data-comapre').replace(',',''));
               if(warranty_compare != ''){
                 var warranty_price = parseFloat($(this).attr('data-comapre').replace(',',''));
               }else{
                 var warranty_price = parseFloat($(this).attr('data-price').replace(',',''));
               }
             
               var discount_one = $(document).find(".discount_one").attr('discount-price');
               var discount_two = $(document).find(".discount_two").attr('discount-price');
               var discount_three = $(document).find(".discount_three").attr('discount-price');
               var discount_four = $(document).find(".discount_four").attr('discount-price');
               var discount_five = $(document).find(".discount_five").attr('discount-price');

                 if(discount_one != '' && discount_one != undefined){
                     var final_discount = parseFloat(warranty_price)*parseFloat(discount_one)/100;
                     var final_discount = final_discount.toFixed(2);
                     $(document).find(".discount_one  p").text(currency_symbol+final_discount);
                     //$(document).find(".discount_one  input").attr('data-fianl',final_discount);
                 }
          
                 if(discount_two != '' && discount_two != undefined){
                     var final_discount = parseFloat(warranty_price)*parseFloat(discount_two)/100;
                     var final_discount = final_discount.toFixed(2);
                     $(document).find(".discount_two  p").text(currency_symbol+final_discount);
                     //$(document).find(".discount_two  input").attr('data-fianl',final_discount);
                 }
          
                 if(discount_three != '' && discount_three != undefined){
                     var final_discount = parseFloat(warranty_price)*parseFloat(discount_three)/100;
                     var final_discount = final_discount.toFixed(2);
                     $(document).find(".discount_three  p").text(currency_symbol+final_discount);
                     //$(document).find(".discount_three  input").attr('data-fianl',final_discount);
                 }
          
                if(discount_four != '' && discount_four != undefined){
                     var final_discount = parseFloat(warranty_price)*parseFloat(discount_four)/100;
                     var final_discount = final_discount.toFixed(2);
                     $(document).find(".discount_four  p").text(currency_symbol+final_discount);
                     //$(document).find(".discount_four  input").attr('data-fianl',final_discount);
                 }
          
                if(discount_five != '' && discount_five != undefined){
                     var final_discount = parseFloat(warranty_price)*parseFloat(discount_five)/100;
                     var final_discount = final_discount.toFixed(2);
                     $(document).find(".discount_five  p").text(currency_symbol+final_discount);
                     //$(document).find(".discount_five  input").attr('data-fianl',final_discount);
                 }
             
          }
        
      });
     
      $("#custom_server_varaint > option").each(function() {
        
         var ths_value = $(this).attr('value');
         if(ths_value == warranty_value){
           
           var currency_symbol = $(document).find("body").attr('data-symbol');
           if(currency_symbol == '₹'){
             var currency_symbol = 'Rs.';
           }else{
             var currency_symbol = '$';
           }
           var warranty_price = ''
           var warranty_compare = parseFloat($(this).attr('data-comapre'));
           if(warranty_compare != ''){
             var warranty_price = parseFloat($(this).attr('data-comapre'));
           }else{
             var warranty_price = parseFloat($(this).attr('data-price'));
           }
           
             var discount_one = $(document).find(".discount_one").attr('discount-price');
             var discount_two = $(document).find(".discount_two").attr('discount-price');
             var discount_three = $(document).find(".discount_three").attr('discount-price');
             var discount_four = $(document).find(".discount_four").attr('discount-price');
             var discount_five = $(document).find(".discount_five").attr('discount-price');

             if(discount_one != '' && discount_one != undefined){
                 var final_discount = parseFloat(warranty_price)*parseFloat(discount_one)/100;
                 var final_discount = final_discount.toFixed(2);
                 //$(document).find(".discount_one  p").text(currency_symbol+final_discount);
                 $(document).find(".discount_one  input").attr('data-fianl',final_discount);
             }
      
             if(discount_two != '' && discount_two != undefined){
                 var final_discount = parseFloat(warranty_price)*parseFloat(discount_two)/100;
                 var final_discount = final_discount.toFixed(2);
                 //$(document).find(".discount_two  p").text(currency_symbol+final_discount);
                 $(document).find(".discount_two  input").attr('data-fianl',final_discount);
             }
      
             if(discount_three != '' && discount_three != undefined){
                 var final_discount = parseFloat(warranty_price)*parseFloat(discount_three)/100;
                 var final_discount = final_discount.toFixed(2);
                 //$(document).find(".discount_three  p").text(currency_symbol+final_discount);
                 $(document).find(".discount_three  input").attr('data-fianl',final_discount);
             }
      
            if(discount_four != '' && discount_four != undefined){
                 var final_discount = parseFloat(warranty_price)*parseFloat(discount_four)/100;
                 var final_discount = final_discount.toFixed(2);
                 //$(document).find(".discount_four  p").text(currency_symbol+final_discount);
                 $(document).find(".discount_four  input").attr('data-fianl',final_discount);
             }
      
            if(discount_five != '' && discount_five != undefined){
                 var final_discount = parseFloat(warranty_price)*parseFloat(discount_five)/100;
                 var final_discount = final_discount.toFixed(2);
                 //$(document).find(".discount_five  p").text(currency_symbol+final_discount);
                 $(document).find(".discount_five  input").attr('data-fianl',final_discount);
             }
           
         }
        
     });

   }
  

  $('#AddToCartForm-product-template .product-form__input').on('change', function() {

       setTimeout(function() {
         var searchParams = new URLSearchParams(window.location.search)
         var warranty_value = searchParams.get('variant');

             $(".itg_custom_discount > option").each(function() {
                
                 var ths_value = $(this).attr('value');
                 if(ths_value == warranty_value){
        
                     var currency_symbol = $(document).find("body").attr('data-symbol');
                     if(currency_symbol == '₹'){
                       var currency_symbol = 'Rs.';
                     }else{
                       var currency_symbol = '$';
                     }
                     var warranty_price = ''
                     var warranty_compare = parseFloat($(this).attr('data-comapre').replace(',',''));
                     if(warranty_compare != ''){
                       var warranty_price = parseFloat($(this).attr('data-comapre').replace(',',''));
                     }else{
                       var warranty_price = parseFloat($(this).attr('data-price').replace(',',''));
                     }
                   
                     var discount_one = $(document).find(".discount_one").attr('discount-price');
                     var discount_two = $(document).find(".discount_two").attr('discount-price');
                     var discount_three = $(document).find(".discount_three").attr('discount-price');
                     var discount_four = $(document).find(".discount_four").attr('discount-price');
                     var discount_five = $(document).find(".discount_five").attr('discount-price');
      
                       if(discount_one != '' && discount_one != undefined){
                           var final_discount = parseFloat(warranty_price)*parseFloat(discount_one)/100;
                           var final_discount = final_discount.toFixed(2);
                           $(document).find(".discount_one  p").text(currency_symbol+final_discount);
                           //$(document).find(".discount_one  input").attr('data-fianl',final_discount);
                       }
                
                       if(discount_two != '' && discount_two != undefined){
                           var final_discount = parseFloat(warranty_price)*parseFloat(discount_two)/100;
                           var final_discount = final_discount.toFixed(2);
                           $(document).find(".discount_two  p").text(currency_symbol+final_discount);
                           //$(document).find(".discount_two  input").attr('data-fianl',final_discount);
                       }
                
                       if(discount_three != '' && discount_three != undefined){
                           var final_discount = parseFloat(warranty_price)*parseFloat(discount_three)/100;
                           var final_discount = final_discount.toFixed(2);
                           $(document).find(".discount_three  p").text(currency_symbol+final_discount);
                           //$(document).find(".discount_three  input").attr('data-fianl',final_discount);
                       }
                
                      if(discount_four != '' && discount_four != undefined){
                           var final_discount = parseFloat(warranty_price)*parseFloat(discount_four)/100;
                           var final_discount = final_discount.toFixed(2);
                           $(document).find(".discount_four  p").text(currency_symbol+final_discount);
                           //$(document).find(".discount_four  input").attr('data-fianl',final_discount);
                       }
                
                      if(discount_five != '' && discount_five != undefined){
                           var final_discount = parseFloat(warranty_price)*parseFloat(discount_five)/100;
                           var final_discount = final_discount.toFixed(2);
                           $(document).find(".discount_five  p").text(currency_symbol+final_discount);
                           //$(document).find(".discount_five  input").attr('data-fianl',final_discount);
                       }
                }
              
            });
         
             $("#custom_server_varaint > option").each(function() {
               
               var ths_value = $(this).attr('value');
               
               if(ths_value == warranty_value){

                   var currency_symbol = $(document).find("body").attr('data-symbol');
                   if(currency_symbol == '₹'){
                     var currency_symbol = 'Rs.';
                   }else{
                     var currency_symbol = '$';
                   }
                 
                   var warranty_price = ''
                   var warranty_compare = parseFloat($(this).attr('data-comapre'));
                   if(warranty_compare != ''){
                     var warranty_price = parseFloat($(this).attr('data-comapre'));
                   }else{
                     var warranty_price = parseFloat($(this).attr('data-price'));
                   }

                   var discount_one = $(document).find(".discount_one").attr('discount-price');
                   var discount_two = $(document).find(".discount_two").attr('discount-price');
                   var discount_three = $(document).find(".discount_three").attr('discount-price');
                   var discount_four = $(document).find(".discount_four").attr('discount-price');
                   var discount_five = $(document).find(".discount_five").attr('discount-price');

                   if(discount_one != '' && discount_one != undefined){
                       var final_discount = parseFloat(warranty_price)*parseFloat(discount_one)/100;
                       var final_discount = final_discount.toFixed(2);
                       //$(document).find(".discount_one  p").text(currency_symbol+final_discount);
                       $(document).find(".discount_one  input").attr('data-fianl',final_discount);
                   }
                   if(discount_two != '' && discount_two != undefined){
                       var final_discount = parseFloat(warranty_price)*parseFloat(discount_two)/100;
                       var final_discount = final_discount.toFixed(2);
                      //$(document).find(".discount_two  p").text(currency_symbol+final_discount);
                       $(document).find(".discount_two  input").attr('data-fianl',final_discount);
                   }
                   if(discount_three != '' && discount_three != undefined){
                     var final_discount = parseFloat(warranty_price)*parseFloat(discount_three)/100;
                     var final_discount = final_discount.toFixed(2);
                     //$(document).find(".discount_three  p").text(currency_symbol+final_discount);
                     $(document).find(".discount_three  input").attr('data-fianl',final_discount);
                   }
                   if(discount_four != '' && discount_four != undefined){
                     var final_discount = parseFloat(warranty_price)*parseFloat(discount_four)/100;
                     var final_discount = final_discount.toFixed(2);
                     //$(document).find(".discount_four  p").text(currency_symbol+final_discount);
                     $(document).find(".discount_four  input").attr('data-fianl',final_discount);
                  }
                  if(discount_five != '' && discount_five != undefined){
                       var final_discount = parseFloat(warranty_price)*parseFloat(discount_five)/100;
                       var final_discount = final_discount.toFixed(2);
                       //$(document).find(".discount_five  p").text(currency_symbol+final_discount);
                       $(document).find(".discount_five  input").attr('data-fianl',final_discount);
                   }
      
               }
               
             });
         
        }, 800);
  });


  $(document).on("click","#dcodeSubmit_cus",function() {
     var discount_code = $(document).find("#dcodeInput_cus").val();
     if(discount_code != ''){
          $(document).find("#dcodeSubmit_cus span").text("Wait..");
          var form_data_client = new FormData();
          form_data_client.append("discountcode", discount_code);
          $(document).find("#discount_error").hide();
          $.ajax({
              type: "POST",
              url: "https://dev.shopifyexperthelp.com/app/project_custom_code/deluxe/discount_code.php",
              data: form_data_client,
              contentType: false,
              processData: false,
              success: function(resp) {
                 $(document).find("#discount_name").text('');
                 $(document).find("#discount_code_price").text('');
                 $(document).find("#finalcarttotal").text('');
                 $(document).find("#dcodeSubmit_cus span").text("Apply");
                 $(document).find("#apply_discount").val('');
                var respData = JSON.parse(resp);
                if(respData['status'] == 1){
                  
                  var regionData = parseFloat(respData['discountval'].replace('-','')); 
                  var currency_symbol = $(document).find("body").attr('data-symbol');
                  var carttotal = parseFloat($(document).find("#CartSubtotal").text().replace(',','').replace(currency_symbol,''));
                  var finalprice = carttotal*regionData/100;
                  var finalprice = finalprice.toFixed(2);
                  
                  $(document).find("#discount_code_price").text(finalprice);
                  $(document).find("#discount_name").text(discount_code);

                  var discountfinalprice = carttotal - finalprice;
                  var discountfinalprice = discountfinalprice.toFixed(2);
                  $(document).find("#finalcarttotal").text(currency_symbol+''+discountfinalprice);
                  $(document).find("#apply_discount").val(discount_code);

                }else{
                  $(document).find("#discount_error").show();
                  $(document).find("#apply_discount").val('');
                }
              },error: function() {
                 //alert('error');
              }  
          });
     }else{
        $(document).find("#apply_discount").val('');
        alert('Please enter discount code');
        return false;
     }
  });

  $(document).on("click",".custom_cart_remove",function() {
      var randomNumber = $(this).attr('data-remove');
      var data = { updates: {} };
      $("tbody#CartProducts tr").each(function(){
            var getNumber = $(this).attr('data-number');
            if(getNumber == randomNumber){
               var variantid = $(this).attr('data-cartid');
               var qty = 0;
               data.updates[variantid] = qty; 
            }
       });
       jQuery.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: data,
          dataType: 'json',
          success: function(data) { 
            window.location.href = '/cart';
          }
       });   
  });

  $('.metafiled_cart_item').on('change', function() {
    
      var metaval = $(this).find(":selected").val();
      var metatitle = $.trim($(this).find(":selected").text());
      var metavalhandle = $(this).find(":selected").attr('data-selhandle');
      var metavalnumber = $(this).find(":selected").attr('data-selnumber');
      var random_number = 1 + Math.floor(Math.random() * 1000);
      var currency_symbol = $(document).find("body").attr('data-symbol');
  
       $("tbody#CartProducts tr").each(function(){
         
          var getNumber = $(this).attr('data-number');
           if(getNumber == metavalnumber){
              var ths_handle = $.trim($(this).attr('data-mainhandle'));
              if(ths_handle == metavalhandle){
                
                  var variantid = $(this).attr('data-cartid');
                  var qty = $(this).find('.js-qty__input').val();

                    var main_item_price = '';
                    var currency_symbol = $(document).find("body").attr('data-symbol');
                   if(currency_symbol == '₹'){
                     var currency_symbol = 'Rs.';
                     var main_item_price = parseFloat($(this).find('.cart__item-total').text().replace(',','').replace(currency_symbol,''));
                     var main_item_price = (main_item_price / 81.96).toFixed(2);
                    }else{
                      var currency_symbol = '$';
                      var main_item_price = $(this).find('.cart__item-total').text().replace(',','').replace(currency_symbol,'');
                    }
               
                  var final_discount = parseFloat(main_item_price)*parseFloat(metaval)/100;
                  var final_discount = final_discount.toFixed(2);
                   //alert(final_discount);
                  var fd = new FormData();
                  fd.append("price",final_discount);

                     $(document).find(".custom_loader-bg").css("display", "flex");
                
                     $.ajax({
                      url: 'https://dev.shopifyexperthelp.com/app/project_custom_code/deluxe/warranty.php',
                      data: fd,
                      contentType: false,
                      processData: false,
                      type: 'POST',
                      success: function(res){
                       
                          var extra = {
                            "id": res,
                            "quantity": 1,
                            "properties": {
                              "handle":metavalhandle,
                              "Rno": random_number
                            }
                          }
                          jQuery.ajax({
                            type: 'POST',
                            url: '/cart/add.js',
                            data: extra,
                            dataType: 'json',
                            success: function() { 

                               var dataup = { updates: {} };
                               $("tbody#CartProducts tr").each(function(){
                                    var getNumber = $(this).attr('data-number');
                                    if(getNumber == metavalnumber){
                                       var variantid = $(this).attr('data-cartid');
                                       var qty = 0;
                                       dataup.updates[variantid] = 0; 
                                    }
                               });
                               
                               jQuery.ajax({
                                  type: 'POST',
                                  url: '/cart/update.js',
                                  data: dataup,
                                  dataType: 'json',
                                  success: function(data) { 
                                    newdata(variantid,qty,metatitle,random_number);
                                  }
                               });   

                               function newdata(variantid,qty,metatitle,random_number){
                                 var datanew = {
                                    "id": variantid,
                                    "quantity": qty,
                                    "properties": {
                                      "Warranty": metatitle,
                                      "Rno": random_number
                                    }
                                  }
                                  jQuery.ajax({
                                    type: 'POST',
                                    url: '/cart/add.js',
                                    data: datanew,
                                    dataType: 'json',
                                    success: function() { 
                                      window.location.href = '/cart';
                                       //window.location.reload();
                                    },error:function name() {
                                      //alert('alreadsy');
                                    }
                                  });
                               }
                                 
                            },error:function(){
                              alert('error');
                            }
                          });
                      }
                    });
              }
           }
       });
      
  });

  
});  


// ITG js

$(document).on('change','.add_basket_product #ProductSelect-product-template',function () {
  var selected = $(this).find('option:selected').val();
  $(this).parents('.add_on_info').find('span.add_basket_btn.btn.btn--full').attr('data-variant',selected);
});

$(document).on('click','.add_basket_btn',function (e) {
  e.preventDefault();
  var variantId = $(this).data('variant');
  var formData = 'quantity=1&id=' + variantId;
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: formData,
    dataType: 'json',
    success: function(data) { 
      location.href="/cart";
    },
    error: function(status) {
      console.log(status)
    }
  });
});

  function LoopForever() {
    
        var cartnumber = localStorage.getItem("item_varaint");
        if(cartnumber != null){
          $('tbody#CartProducts .responsive-table__row').each(function() {
             var numbervar = $(this).attr('data-cartid');
             if(numbervar == cartnumber){
               $(this).hide();
             }
          });
        }
     
        $('tbody#CartProducts .itg_cart__item-total_warranty').each(function() {
          
            var war_thsnumber = $(this).attr('data-numbercart');
            var war_data_original = parseFloat($(this).attr('data-original').replace(',',''));
            var war_data_symbol = $(this).attr('data-symbol');
  
            $('tbody#CartProducts .itg_cart__item-total').each(function() {
  
               var thsnumber = $(this).attr('data-numbercart');
               var data_original = parseFloat($(this).attr('data-original').replace(',',''));
               var data_symbol = $(this).attr('data-symbol');
               if(thsnumber == war_thsnumber){
                  var finalitem_cart = data_original + war_data_original;
                  var main_item_price = finalitem_cart.toFixed(2);
                    if(data_symbol == '₹'){
                      var main_item_price = main_item_price.replace(/\d+/g, n => Number(n).toLocaleString());
                      $(this).text('Rs. '+main_item_price);
                    }else{
                      $(this).text('$'+main_item_price);
                    }
               }
  
            });
          
        });
  }

var interval = self.setInterval(function(){LoopForever()},500);